import React, {useEffect} from 'react';

const DateSelector = ({ dateRange, setDateRange }) => {
  const [Days, setDays] = React.useState(null);

  const WeekDays = ["zo", "ma", "di", "wo", "do", "vr", "za"]
  const Months = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"]

  const [Data, setData] = React.useState({
    start: {
      day: new Date(dateRange[0]).getDate(),
      month: new Date(dateRange[0]).getMonth() + 1,
      year: new Date(dateRange[0]).getFullYear(),
    },
    stop: {
      day: new Date(dateRange[1]).getDate(),
      month: new Date(dateRange[1]).getMonth() + 1,
      year: new Date(dateRange[1]).getFullYear(),
    },
    month: new Date(dateRange[0]).getMonth() + 1,
    year: new Date(dateRange[0]).getFullYear(),
    select: true,
  });

  const handelDateChange = (data) => {
    if (!data) return null;

    const start = new Date(data.start.year, data.start.month - 1, data.start.day, 0, 0, 0).toISOString()
    const stop = new Date(data.stop.year, data.stop.month - 1, data.stop.day, 23, 59, 59).toISOString();

    setDateRange([start, stop]);
  };

  useEffect(() => {
    let FirstWeekDay = new Date(Data.year, Data.month - 1,1).getDay();
    let LastDayLastMonth = new Date(Data.year, Data.month - 1,0).getDate();
    let LastDateOfMonth = new Date(Data.year, Data.month,0).getDate();
    let LastDayOfMonth = new Date(Data.year, Data.month - 1, LastDateOfMonth).getDay()
    const defaultClass = "flex justify-center px-2 py-0.5 hover:cursor-pointer select-none my-1 "
    const inActiveColor = " bg-gray-100 text-gray-300"
    const ActiveColor = " bg-orange-100"
    const HighlighedColor = " bg-orange-300"

    let NewDays = []

    for(let i = FirstWeekDay - 1; i > -1; i--) {
      NewDays.push({ day: LastDayLastMonth - i, color:inActiveColor, class:defaultClass });
    }

    for(let i = 1; i <= LastDateOfMonth; i++) {
      const isBetween = (i, start, stop) => {
        const startKey = start.year * 100000 + start.month * 1000 + start.day;
        const stopKey = stop.year * 100000 + stop.month * 1000 + stop.day;
        const currentKey = Data.year * 100000 + Data.month * 1000 + i

        return currentKey >= startKey && currentKey <= stopKey || startKey === stopKey && currentKey === startKey;
      }

      const Highlighted = isBetween(i, Data.start, Data.stop)

      const Color = Highlighted ? HighlighedColor : ActiveColor

      NewDays.push({ day: i, color: Color, class:defaultClass })
    }

    for(let i = LastDayOfMonth + 1; i < 7; i++) {
      NewDays.push({ day: i - LastDayOfMonth, color:inActiveColor, class:defaultClass });
    }

    setDays([...NewDays]);
  }, [Data]);

  const Click = (e) => {
    if (Data.select) {
      setData({...Data, start: { day: e.target.value, month: Data.month, year: Data.year }, stop: { day: e.target.value, month: Data.month, year: Data.year }, select: false });
      return null
    } else if (Data.year < Data.start.year || (Data.month < Data.start.month && Data.start.year === Data.year) || (e.target.value <= Data.start.day && Data.start.month === Data.month && Data.start.year === Data.year)) {
      setData({ ...Data, start: { day: e.target.value, month: Data.month, year:Data.year }, stop: Data.start, select: true });
      handelDateChange({ ...Data, start: { day: e.target.value, month: Data.month, year:Data.year }, stop: Data.start, select: true })
    } else {
      setData({ ...Data, stop: { day: e.target.value, month: Data.month, year:Data.year }, select: true });
      handelDateChange({ ...Data, stop: { day: e.target.value, month: Data.month, year:Data.year }, select: true })
    }
  }

  return (
    <div className={"p-2 w-56 font-bold bg-white border-2 z-20 rounded"}>
      <span className={"flex justify-between"}>
        <div className={"font-extrabold text-xl"} onClick={() => {setData(Data.month - 1 >= 1 ? {...Data, month: Data.month - 1} : {...Data, month: 12, year: Data.year - 1})}}>{"<"}</div>
        <div>{Months[Data.month - 1] + " " + Data.year}</div>
        <div className={"font-bold text-xl"} onClick={() => {setData(Data.month + 1 <= 12 ? {...Data, month: Data.month + 1} : {...Data, month: 1, year: Data.year + 1})}}>{">"}</div>
      </span>
      <ul className="grid grid-cols-7">
        {WeekDays ? WeekDays.map((day, i) => (
          <li className={"flex p-1 justify-center"} key={i}>{day}</li>
        )): ""}
        {Days ? Days.map((obj, i) => (
          <li onClick={(e) => {if (obj.color !== " bg-gray-100 text-gray-300") Click(e)}} value={obj.day} className={obj.class + obj.color} key={i}>{obj.day}</li>
        )): ""}
      </ul>
    </div>
  );
};

export default DateSelector;
